export default function formatFileSize (fileSize) {
    if (null === fileSize || '' === fileSize || 0 === fileSize) {
        return '0 Bytes';
    }
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const srcSize = parseFloat(fileSize);
    const index = Math.floor(Math.log(srcSize) / Math.log(1024));
    let size = srcSize / Math.pow(1024, index);
    size = size.toFixed(1);
    return `${size} ${units[index]}`;
}
